<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible="visible"
      width="520px"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => (backDialogVisible = true)"
      append-to-body
    >
      <Main ref="main" />
      <span slot="footer">
        <el-button size="small" @click="backDialogVisible = true">
          {{ $l('INDEX.btn_close') || '关闭' }}
        </el-button>
        <el-button type="primary" size="small" @click="upload()">
          {{ $l('INDEX.btn_upload') || '上传' }}
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
      append-to-body
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="upload()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Main from './main.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    shipmentCustomerCode: { type: String, default: '' },
  },
  data() {
    return { backDialogVisible: false }
  },
  methods: {
    async upload() {
      this.loadingOpen()
      const uploadForm = await this.$refs.main.upload()
      if (!uploadForm) {
        this.loadingClose()
        return
      }

      const res = await this.$api
        .shipmentCustomerFileUploadApi({
          ...uploadForm,
          shipmentCustomerCode: this.shipmentCustomerCode,
        })
        .catch(() => null)
      this.loadingClose()
      const { status } = res || {}
      if (status !== 200) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.uploader_label_status_success') || '上传成功',
        type: 'success',
      })
      this.$emit('reload')
      this.close()
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
